
import { 
	ifAuthenticated, 
	ifAuthenticatedOnline, 
	canAccess, 
	ifAuthenticatedOffline,
	AppTabs,
	Edit,
	Show,
	Create,
	Crud,
	trans
} from '@/router/index'

import SendMail from '@/components/common/SendMail'
import Trouble from '@/components/modules/tickets/Trouble'
import ContractTabs from '@/components/modules/tickets/ContractTabs'
import CarnetMovements from '@/components/modules/tickets/CarnetMovements'
import TroubleClose from '@/components/modules/tickets/TroubleClose'
import VisitsSettings from '@/components/modules/tickets/settings/VisitsSettings'
import InterventionsReport from '@/components/modules/tickets/InterventionsReport'
import TicketsSettings from '@/components/modules/tickets/settings/TicketsSettings'
import TariffsSettings from '@/components/modules/tickets/settings/TariffsSettings'
import ContractsSettings from '@/components/modules/tickets/settings/ContractsSettings'
import ContractorsSettings from '@/components/modules/tickets/settings/ContractorsSettings'
import PlannerSettings from '@/components/modules/tickets/settings/PlannerSettings'
import PlannerCalendar from '@/components/modules/planner/PlannerCalendar'

export const tickets = [
	{
		path: '/contracts',
		redirect: '/tickets/contracts'
	},
	{
		path: '/contractors',
		redirect: '/tickets/contractors'
	},
	{
		path: '/tariffs',
		redirect: '/tickets/tariffs'
	},
	{
		path: '/reports',
		redirect: '/tickets/reports'
	},
	{
		path: '/visits',
		redirect: '/tickets/visits'
	},
	{
		path: '/planner',
		redirect: '/tickets/planner'
	},
	{
		path: '/tickets',
		beforeEnter: ifAuthenticated,
		component: AppTabs, 
		props: {
			tabs: [
				{
					to: '/tickets/',
					text: 'Ticket',
				},		
				{
					to: '/tickets/contracts',
					text: 'contracts',
					model: 'contract'
				},
				{
					to: '/tickets/visits',
					text: 'Manutenzioni',
					model: 'visit'
				},
				{
					to: '/tickets/contractors',
					text: 'contractors',
					model: 'contractor'
				},
				{
					to: '/tickets/tariffs',
					text: 'Tariffe',
					model: 'tariff'
				},
				{
					to: '/tickets/reports',
					text: 'Report',
					model: 'report'
				},
				{
					to: '/tickets/planner',
					text: 'Pianificatore',
					model: 'planner'
				},
			],
		},
		children: [
			{
				path: '/tickets/',
				name: 'troubles-index',
				meta: {
					title: trans('tickets')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'troubles',
					actionIcon: 'receipt',
					title: 'Ticket',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/tickets/contracts',
				name: 'contracts-index',
				meta: {
					title: 'contracts',
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'contracts',
					actionIcon: 'library_books',
					title: 'contracts',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/tickets/visits',
				meta: {
					title: trans('visits')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'visits',
					actionIcon: 'build',
					title: 'Manutenzioni'
				}
			},
			{
				path: '/tickets/contractors',
				name: 'contractors-index',
				meta: {
					title: trans('contractors')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'contractors',
					actionIcon: 'business',
					title: 'contractors',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/tickets/tariffs',
				name: 'tariffs-index',
				meta: {
					title: trans('tariffs')
				},
				beforeEnter: ifAuthenticated,
				component: Crud,
				props: {
					modelDef: 'tariffs',
					actionIcon: 'receipt',
					title: 'Tariffe',
					styleClass: 'mb-offset'
				}
			},
			{
				path: '/tickets/reports',
				meta: {
					title: trans('report')
				},
				beforeEnter: ifAuthenticatedOnline,
				component: InterventionsReport,
				props: {
					modelDef: 'interventionsreports'
				}
			},
			{
				path: '/tickets/planner',
				name: 'planner-index',
				meta: {
					title: 'Pianificatore'
				},
				beforeEnter: (to, from, next) => { ifAuthenticatedOnline(to, from, next), canAccess('permission', 'planner', next) },
				component: PlannerCalendar,
			},
		],
	},
	{ 
		path: '/tickets/troubles/create',
		name: 'troubles-create', 
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'troubles',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},	
	{ 
		path: '/tickets/troubles/:id/edit',
		name: 'troubles-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'troubles',
			id:  parseInt(route.params.id)
		}),
	},
	{ 
		path: '/tickets/troubles/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/tickets/troubles/' + parseInt(route.params.id) + '/',
					text: 'Ticket',
				},
				{
					to: '/tickets/troubles/' + parseInt(route.params.id) + '/ddts',
					text: 'DDT Interventi',
					model: 'ddt'
				}
			]
		}),
		children: [
			{
				path: '',
				name: 'troubles-show', 
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Trouble,
				meta: {
					title: 'Ticket'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
				}),
			},
			{
				path: 'ddts',
				name: 'troubles-ddts',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'ddt', next) },
				component: Crud,
				meta: {
					title: 'DDT'
				},
				props: (route) => ({
					modelDef: 'ddts',
					actionIcon: 'local_shipping',
					title: 'DDT associati in Interventi',
					styleClass: 'mb-offset',
					subFilters: {troubleInterventions: parseInt(route.params.id)},
					defaultInput: {
						trouble_id: parseInt(route.params.id),
						company_id: parseInt(route.query.company_id)
					}
				}),
			}
		]
	},
	{ 
		path: '/tickets/troubles-close/:id',
		beforeEnter: ifAuthenticated,
		component: AppTabs,
		props: (route) => ({
			tabs: [
				{
					to: '/tickets/troubles-close/' + parseInt(route.params.id) + '/',
					text: 'Chiusura Ticket',
				},			
			]
		}),
		children: [
			{
				path: '',
				name: 'troubles-close',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: TroubleClose,
				meta: {
					title: 'Chiusura Ticket'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
				}), 
			},
		]
	},
	{ 
		path: '/tickets/contracts/create',
		name: 'contracts-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'contracts',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/tickets/contracts/:id/edit',
		name: 'contracts-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'contracts',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/tickets/contracts/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: ContractTabs,
		props: (route) => ({
			id:  parseInt(route.params.id),
		}), 
		children: [
			{
				path: '',
				name: 'contracts-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'contract', next),
				component: Show,
				meta: {
					title: 'Contratto'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef: 'contracts',
					modelClass: 'contract',
					activities: true,
					maillogs: true,
					fileuploader: true
				}), 
			},
			{
				path: 'tickets',
				beforeEnter: (to, from, next) => { ifAuthenticated(to, from, next), canAccess('permission', 'trouble', next) },
				component: Crud,
				meta: {
					title: 'Ticket'
				},
				props: (route) => ({
					modelDef: 'troubles',
					actionIcon: 'location_on',
					title: 'Ticket associati',
					styleClass: 'mb-offset',
					subFilters: {contracts: parseInt(route.params.id)},
					defaultInput: {
						contract_id: parseInt(route.params.id),
						company_id: parseInt(route.query.company_id)
					}
				}),
			},
			{
				path: 'movements',
				beforeEnter: (to, from, next) => canAccess('permission', 'contract', next),
				component: CarnetMovements,
				meta: {
					title: 'Movimenti Ore'
				},
				props: (route) => ({
					id: parseInt(route.params.id),
					apiPrefix: 'contracts',
				}),
			},
		]
	},
	{ 
		path: '/tickets/contractors/create',
		name: 'contractors-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'contractors',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/tickets/contractors/:id/edit',
		name: 'contractors-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'contractors',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/tickets/contractors/:id',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Appaltatore',
				},
			],
		}, 
		children: [
			{
				path: '/tickets/contractors/:id',
				name: 'contractors-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'contractor', next),
				component: Show,
				meta: {
					title: 'Appaltatore'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'contractors',
					modelClass: 'contractor',
					activities: true,
					fileuploader: true
				}), 
			},
		]
	},
	{ 
		path: '/tickets/tariffs/create',
		name: 'tariffs-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'tariffs',
			defaultInput: route.params.defaultInput ? route.params.defaultInput : null,
			redirect: route.params.redirect
		}),
	},
	{ 
		path: '/tickets/tariffs/:id/edit',
		name: 'tariffs-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'tariffs',
			id:  parseInt(route.params.id),
		}),
	},
	{ 
		path: '/tickets/tariffs/:id',
		name: 'tariffs',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '',
					text: 'Tariffario',
				},
			],
		}, 
		children: [
			{
				path: '/tickets/tariffs/:id',
				name: 'tariffs-show', 
				beforeEnter: (to, from, next) => canAccess('permission', 'tariff', next),
				component: Show,
				meta: {
					title: 'Tariffario'
				},				
				props: (route) => ({
					id:  parseInt(route.params.id),
					modelDef: 'tariffs',
					modelClass: 'tariff',
					activities: true,
				}), 
			},
		]
	},
	{ 
		path: '/settingstickets/templates-trouble/create',
		name: 'templates-trouble-create',
		beforeEnter: ifAuthenticatedOnline,
		component: Create,
		props: (route) => ({
			modelDef:  'templates-trouble',
			redirect: route.params.redirect,
			defaultInput: {type: 'trouble'},			
		}),
	},	
	{ 
		path: '/settingstickets/templates-trouble/:id/edit',
		name: 'templates-trouble-edit',
		beforeEnter: ifAuthenticatedOnline,
		component: Edit,
		props: (route) => ({
			modelDef:  'templates-trouble',
			id:  parseInt(route.params.id),
			defaultInput: {type: 'trouble'},
		}), 
	},
	{ 
		path: '/settingstickets/templates-trouble/:id',
		component: AppTabs, 	
		props: (route) => ({
			tabs: [
				{
					to: '/settingstickets/templates-trouble/' + parseInt(route.params.id) + '/',
					text: 'Template Ticket',
				},
			],
		}),
		children: [
			{
				path: '',
				name: 'templates-trouble-show', 
				beforeEnter: ifAuthenticatedOnline,
				component: Show,
				meta: {
					title: 'Template Ticket'
				},				
				props: (route) => ({
					id: parseInt(route.params.id),
					modelDef:  'templates-trouble',
					modelClass:  'template',
					activities: true
				}), 
			},
		]
	},
	{
		path: '/troubles/troubles-send-mail/:id',
		name: 'troubles-send-mail',
		beforeEnter: ifAuthenticatedOnline,
		component: SendMail,
		props: (route) => ({
			id: parseInt(route.params.id),
			title: route.query.type === 'close' ? 'Invio Rapporto Chiusura' : 'Invio Rapporto Intervento',
			model_name: 'trouble',
			route: 'troubles',
			sendType: route.query.type || 'intervention',
			attachmentIncluded: route.query.type === 'close'
		}),
	},
	{
		path: '/settingstickets/',
		name: 'settingstickets',
		beforeEnter: ifAuthenticatedOnline,
		component: AppTabs,
		props: {
			tabs: [
				{
					to: '/settingstickets',
					text: 'Ticket',
				},
				{
					to: '/settingstickets/contracts',
					text: 'Contratti',
				},			
				{
					to: '/settingstickets/visits',
					text: 'Manutenzioni',
				},			
				{
					to: '/settingstickets/contractors',
					text: 'contractors',
				},
				{
					to: '/settingstickets/tariffs',
					text: 'Tariffe',
				},
				{
					to: '/settingstickets/planner',
					text: 'Pianificatore',
				}
			],
		},
		children: [
			{
				path: '/settingstickets/',
				beforeEnter: ifAuthenticatedOnline,
				component: TicketsSettings,
			},
			{
				path: '/settingstickets/contracts',
				beforeEnter: ifAuthenticatedOnline,
				component: ContractsSettings,
			},
			{
				path: '/settingstickets/visits',
				beforeEnter: ifAuthenticatedOnline,
				component: VisitsSettings,
			},
			{
				path: '/settingstickets/contractors',
				beforeEnter: ifAuthenticatedOnline,
				component: ContractorsSettings,
			},
			{
				path: '/settingstickets/tariffs',
				beforeEnter: ifAuthenticatedOnline,
				component: TariffsSettings,
			},
			{
				path: '/settingstickets/planner',
				beforeEnter: (to, from, next) => { ifAuthenticatedOnline(to, from, next), canAccess('permission', 'planner', next) },
				component: PlannerSettings,
			},
		],
	},
]